<template>
	<div class="channels-table-page">
		<vx-card class="my-8">
			<div class="tab-text ">
				<vs-table :max-items="10" pagination :data="channels">
					<template slot="thead">
						<vs-th v-for="fil in field" :style="'width:' +fil.width" :class="{'justify-center': fil.align && fil.align === 'center'}">
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr class="vs-table-filters">
							<template v-for="fil in field">
								<vs-td v-if="fil.field === 'name'">
									<vs-input class="w-full" v-model="searchName" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'plainId'">
									<vs-input class="w-full" v-model="searchPlainId" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'manager'">
									<vs-input class="w-full" v-model="searchManager" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else></vs-td>
							</template>
						</vs-tr>
						<vs-tr :key="indextr"  v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'actions'">
									<div class="flex justify-center">
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="$router.push(`/whatsapp/channels/edit/${tr.id}`)"
											icon="edit"
										>
											<feather-icon icon="EditIcon"></feather-icon>
										</vs-button>
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'plainId'">
		                            <div								
									>
										<strong>{{ tr[fil.field] }}</strong>
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'state'">
		                            <div 
                                        v-if="tr[fil.field] == 'active'"		
                                        style="color: green; font-weight: bolder;"						
									>
                                        {{ $t('listStateChannelWhatsapp.' + tr[fil.field]) }}
									</div>
		                            <div 
                                        v-else								
                                        style="color: red; font-weight: bolder;"						
                                    >
                                        {{ $t('listStateChannelWhatsapp.' + tr[fil.field]) }}
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="tr[fil.field]">
									{{tr[fil.field]}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
									...
								</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import vSelect from 'vue-select';
import debounce from 'debounce';

export default {
	name: "ListChannelWhatsapp",
	mixins: [databaseManager, notifier],
	components: {
		'v-select': vSelect,
	},
	data() {
		return {
			channels: [],
            searchName: '',
            searchPlainId: '',
            searchManager: '',
		};
	},
	methods: {
		// showDeleteDialog(id, name) {
		// 	this.$vs.dialog({
		// 		color: "danger",
		// 		title: this.$t('confirmDeletion'),
		// 		acceptText: this.$t('delete'),
		// 		cancelText: this.$t('cancel'),
		// 		text: `${this.$t('doYouWantToDelete')} "${name}"`,
		// 		accept: () => this.removeTask(id),
		// 	});
		// },
		// async removeTask(id){
		// 	try {
		// 		await this.dbDeleteWebsite(id);

		// 		const index = this.channels.findIndex(item => item.id === id);

		// 		if(index !== -1) this.channels.splice(index, 1);

		// 		this.notifySuccess(this.$t('deletedSuccessfully'));

		// 	} catch (e) {
		// 		this.notifyError(e.message);
		// 	}
		// },
		filterTable:  debounce(function (e) {
			let options = {
				name: this.searchName,
				plainId: this.searchPlainId,
				manager: this.searchManager,
			};

			this.updateTable(options);
		}, 500),
		async updateTable(options) {
			try {
				this.channels = await this.dbGetWhatsappListChannels();
			} catch (e) {
				this.notifyError(e.message);
			}
		},
	},
	created() {
		this.field = [
			{
				field: "plainId",
				title: this.$t('plainChannelWhatsapp'),
				align: 'left',
				width: '25%'
			},
			{
				field: "state",
				title: this.$t('stateChannelWhatsapp'),
				align: 'center',
				width: '10%'
			},
			{
				field: "name",
				title: this.$t('nameChannelWhatsapp'),
				align: 'center',
				width: '25%'
			},
			{
				field: "manager",
				title: this.$t('manager'),
				align: 'center',
				width: '25%'
			},
			{
				field: "actions",
				title: this.$t("actions"),
				align: 'center',
				width: '15%'
			},
		];
	},
	async mounted() {
		await this.updateTable();
	},
};

</script>

<style lang="css" scoped>

</style>